import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { getMeeting, updateMeeting, sendMeetingInstanceTimeBookingReminder } from 'actions/meetings';
import { getMeetingTimeBlocks, deleteMeetingTimeBlock } from 'actions/timeblocks';
import { addError } from 'actions/index';
import { Link } from 'react-router-dom';
import Modal from 'containers/Modals/Modal';
import React, { Component } from 'react';
import { translate } from '@haldor/ui';
import { connect } from 'react-redux';
import { Spinner, Collapsible, Person } from 'UI';
import BookMeeting from '../Form/BookMeeting';
import { TooltipMenu, Icon, Button, Flex, getActiveLanguage } from '@haldor/ui';
import CreateTimeBlocks from 'containers/TimeBlocks/CreateTimeBlocks';
import Select from 'components/Inputs/select';
import moment from 'moment';
import swal from 'sweetalert2';
import DateTime from '_class/DateTime';
import Onboarding from 'containers/Onboarding/Onboarding';
import { updateMeetingTimeBlockSlot } from 'actions/timeblocks';
import './Meeting.scss';
import { Plus, Minus } from 'UI/Icons';

var MeetingOccassions = /*#__PURE__*/function (_Component) {
  _inherits(MeetingOccassions, _Component);

  var _super = _createSuper(MeetingOccassions);

  function MeetingOccassions(props) {
    var _this;

    _classCallCheck(this, MeetingOccassions);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      var tasks = [];
      tasks.push(_this.props.getMeetingTimeBlocks(_this.props.meeting.id));
      Promise.all(tasks).then(function () {
        var steps = _this.state.steps;

        if (_this.props.meeting == "DRAFT") {
          steps.push({
            target: '.publishButton',
            content: 'Här kan du publicera mötet',
            disableBeacon: true,
            isFixed: false
          });
        }

        _this.setState({
          steps: steps,
          loading: false,
          lengthValue: _this.props.meeting.length ? _this.props.meeting.length : '',
          restLengthValue: _this.props.meeting.restLength != null ? _this.props.meeting.restLength : ''
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "getParameterByName", function (name, url) {
      if (!url) url = window.location.href;
      name = name.replace(/[\[\]]/g, '\\$&');
      var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
          results = regex.exec(url);
      if (!results) return null;
      if (!results[2]) return '';
      return decodeURIComponent(results[2].replace(/\+/g, ' '));
    });

    _defineProperty(_assertThisInitialized(_this), "disableTimeChange", function (timeblock) {
      var meeting = _this.props.meeting;

      if (meeting == null) {
        return true;
      }

      var foundInstanceWithDate = _this.props.meeting.instances.find(function (instance) {
        if (timeblock != null && instance.date != null) {
          var instanceDate = moment.utc(instance.date);
          return instanceDate.local().isBetween(moment.utc(timeblock.startTime).subtract(5, 'seconds').local(), moment.utc(timeblock.endTime).add(5, 'seconds').local());
        }

        return instance.date != null;
      });

      if (foundInstanceWithDate != null) {
        return true;
      }

      return false;
    });

    _defineProperty(_assertThisInitialized(_this), "removeTimeBlock", /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(timeblock) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return swal.fire({
                  title: _this.props.translate('are-you-sure'),
                  text: _this.props.translate('are-you-sure-you-want-to-delete'),
                  showCancelButton: true,
                  focusConfirm: false,
                  cancelButtonText: _this.props.translate('No'),
                  confirmButtonText: _this.props.translate('Delete')
                });

              case 2:
                _context.next = 4;
                return _this.props.deleteMeetingTimeBlock(_this.props.meeting.id, timeblock.id);

              case 4:
                _context.next = 6;
                return _this.props.getMeetingTimeBlocks(_this.props.meeting.id);

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "sendReminderToAllUnbookInstances", function () {
      var meeting = _this.props.meeting;

      if (meeting.instances != null) {
        var promises = [];
        meeting.instances.forEach(function (instance) {
          if (instance.date == null) {
            promises.push(_this.sendReminder(instance, false));
          }
        });
        Promise.all(promises).then(function () {
          _this.props.addError(_this.props.translate('reminders-sent'), 'info');
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "sendReminder", function (instance) {
      var notify = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      return new Promise(function (resolve) {
        _this.props.sendMeetingInstanceTimeBookingReminder(_this.props.meeting.id, instance.id).then(function () {
          if (notify) _this.props.addError(_this.props.translate('reminders-sent'), 'info');
          resolve(1);
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "toggleTimeBlocksModal", /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(timeblock) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(_this.props.meeting.length == null || _this.props.meeting.length === "")) {
                  _context2.next = 3;
                  break;
                }

                swal.fire({
                  title: _this.props.translate('notice') + '!',
                  text: _this.props.translate('meeting-length-rest-validate-message'),
                  showCancelButton: false,
                  confirmButtonText: _this.props.translate('okey')
                });
                return _context2.abrupt("return");

              case 3:
                if (!(_this.props.meeting.restLength == null || _this.props.meeting.restLength === "")) {
                  _context2.next = 6;
                  break;
                }

                swal.fire({
                  title: _this.props.translate('notice') + '!',
                  text: _this.props.translate('meeting-length-rest-validate-message'),
                  showCancelButton: false,
                  confirmButtonText: _this.props.translate('okey')
                });
                return _context2.abrupt("return");

              case 6:
                if (!_this.state.timeBlocksModal) {
                  _context2.next = 9;
                  break;
                }

                _context2.next = 9;
                return _this.props.getMeetingTimeBlocks(_this.props.meeting.id);

              case 9:
                _this.setState({
                  timeBlocksModal: !_this.state.timeBlocksModal,
                  editTimeblock: timeblock
                });

              case 10:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x2) {
        return _ref2.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "getLengthDurations", function () {
      var times = [];
      var increment = 5;

      for (var i = 0; i < 24; i++) {
        if (i == 0) {
          times.push({
            text: increment + ' ' + _this.props.translate('minutes'),
            value: i + increment
          });
        } else {
          times.push({
            text: (i + 1) * increment + ' ' + _this.props.translate('minutes'),
            value: (i + 1) * increment
          });
        }
      }

      return times;
    });

    _defineProperty(_assertThisInitialized(_this), "getRestLength", function () {
      var times = [];
      var increment = 5;

      for (var i = 0; i < 13; i++) {
        if (i == 0) {
          times.push({
            text: i + ' ' + _this.props.translate('minutes'),
            value: i
          });
        } else {
          times.push({
            text: i * increment + ' ' + _this.props.translate('minutes'),
            value: i * increment
          });
        }
      }

      return times;
    });

    _defineProperty(_assertThisInitialized(_this), "setLengthDuration", /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(event) {
        var meeting;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                meeting = _this.props.meeting;
                meeting.length = event.target.value;
                _context3.next = 4;
                return _this.props.updateMeeting(meeting);

              case 4:
                _context3.next = 6;
                return _this.props.getMeetingTimeBlocks(_this.props.meeting.id);

              case 6:
                _this.props.addError(_this.props.translate('changes-saved'), 'info');

              case 7:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function (_x3) {
        return _ref3.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "setSlotBookable", /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(meeting, timeBlockSlot, bookable) {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                timeBlockSlot.bookable = bookable;
                _context4.next = 3;
                return _this.props.updateMeetingTimeBlockSlot(meeting.id, timeBlockSlot);

              case 3:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      return function (_x4, _x5, _x6) {
        return _ref4.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "setRestDuration", /*#__PURE__*/function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(event) {
        var meeting;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                meeting = _this.props.meeting;
                meeting.restLength = event.target.value;
                _context5.next = 4;
                return _this.props.updateMeeting(meeting);

              case 4:
                _context5.next = 6;
                return _this.props.getMeetingTimeBlocks(_this.props.meeting.id);

              case 6:
                _this.props.addError(_this.props.translate('changes-saved'), 'info');

              case 7:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));

      return function (_x7) {
        return _ref5.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "toggleBooking", function (instance) {
      var reload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var meeting = _this.props.meeting;

      _this.setState({
        bookingModal: !_this.state.bookingModal,
        bookingInstance: instance
      });

      if (reload) {
        _this.props.getMeeting(meeting.id).then(function () {
          _this.setState({
            lengthValue: _this.props.meeting.length ? _this.props.meeting.length : '',
            restLengthValue: _this.props.meeting.restLength != null ? _this.props.meeting.restLength : '',
            loading: false
          });
        })["catch"](function (err) {
          console.log(err);

          _this.setState({
            notFound: true
          });
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "renderMeetingProgress", function (meeting) {
      var width = 0;

      if (meeting.totalMeetings != 0 && meeting.meetingsCompleted != 0) {
        width = meeting.meetingsCompleted / meeting.totalMeetings * 100;
      }

      return meeting.totalMeetings != null && meeting.meetingsCompleted != null ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'flex',
          width: '95%'
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          flex: 1
        }
      }, _this.props.translate('completed-meeting')), /*#__PURE__*/React.createElement("div", {
        style: {
          flex: 1,
          textAlign: 'right'
        }
      }, meeting.meetingsCompleted, " / ", meeting.totalMeetings)), /*#__PURE__*/React.createElement("div", {
        style: {
          backgroundColor: '#e2e2e2',
          width: '95%'
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          backgroundColor: '#40d07c',
          width: "".concat(width, "%"),
          height: '8px'
        }
      }))) : null;
    });

    _defineProperty(_assertThisInitialized(_this), "renderDatePickers", function () {
      if (_this.disableTimeChange()) {
        return /*#__PURE__*/React.createElement("div", {
          className: "meeting-info"
        }, /*#__PURE__*/React.createElement(Icon, {
          name: "Alert"
        }), " ", _this.props.translate('You can not delete or edit time slots where there are booked meetings.'));
      }

      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        className: "meeting-info"
      }, /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement(Icon, {
        name: "Alert"
      }), " ", _this.props.translate('meeting-occassions-text'), "."), /*#__PURE__*/React.createElement("p", null, _this.props.translate('You can only edit time slots as long as no meetings have been booked.'))), /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'flex',
          justifyContent: 'center'
        },
        className: "occassions-datePickers"
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          flex: '1',
          margin: '1rem 0'
        }
      }, /*#__PURE__*/React.createElement("span", {
        style: {
          display: 'block',
          marginBottom: '.3rem'
        }
      }, _this.props.translate('meeting-length')), /*#__PURE__*/React.createElement(Select, {
        selectedValue: _this.state.lengthValue.toString(),
        options: _this.getLengthDurations(),
        placeholderValue: '',
        placeholder: _this.props.translate('select-meeting-length'),
        onChange: function onChange(event) {
          _this.setLengthDuration(event);
        }
      })), /*#__PURE__*/React.createElement("div", {
        style: {
          flex: '1',
          margin: '1rem 0',
          marginLeft: '1rem'
        }
      }, /*#__PURE__*/React.createElement("span", {
        style: {
          display: 'block',
          marginBottom: '.3rem'
        }
      }, _this.props.translate('meeting-rest-length')), /*#__PURE__*/React.createElement(Select, {
        selectedValue: _this.state.restLengthValue.toString(),
        options: _this.getRestLength(),
        placeholderValue: '',
        placeholder: _this.props.translate('select-meeting-rest-length'),
        onChange: function onChange(event) {
          _this.setRestDuration(event);
        }
      }))));
    });

    _defineProperty(_assertThisInitialized(_this), "renderUnbookedInstances", function () {
      var instances = _this.props.meeting.instances.filter(function (t) {
        return t.date == null;
      });

      if (instances.length == 0) {
        return null;
      }

      var trigger = function trigger(open) {
        return /*#__PURE__*/React.createElement("div", {
          className: "meeting-time-blocks--content"
        }, /*#__PURE__*/React.createElement("div", {
          className: "meeting-time-blocks--title"
        }, _this.props.translate('not-booked'), " (", instances.length, ")"), /*#__PURE__*/React.createElement("div", {
          className: "open-indicator"
        }, open ? /*#__PURE__*/React.createElement(Minus, null) : /*#__PURE__*/React.createElement(Plus, null)));
      };

      return /*#__PURE__*/React.createElement("div", {
        className: "meeting--slots time-blocks",
        id: "unbookedInstances"
      }, /*#__PURE__*/React.createElement(Collapsible, {
        trigger: trigger,
        open: _this.state.onboarding ? false : false
      }, instances.map(function (instance) {
        var dropdownTrigger = /*#__PURE__*/React.createElement("div", {
          className: "dropdown--trigger"
        }, /*#__PURE__*/React.createElement(Icon, {
          name: "Bullets"
        }));
        return /*#__PURE__*/React.createElement("div", {
          key: instance.id,
          style: {
            paddingBottom: '1.9rem'
          }
        }, /*#__PURE__*/React.createElement(Flex, {
          center: true
        }, /*#__PURE__*/React.createElement("div", {
          style: {
            flex: 1
          }
        }, /*#__PURE__*/React.createElement(Link, {
          to: "/meeting/".concat(_this.props.meeting.id, "/instance/").concat(instance.id)
        }, /*#__PURE__*/React.createElement(Person, {
          person: instance.student
        }))), /*#__PURE__*/React.createElement("div", {
          style: {
            flex: 1
          }
        }, /*#__PURE__*/React.createElement(Flex, {
          center: true
        }, /*#__PURE__*/React.createElement("div", {
          className: "text--right",
          style: {
            flex: 1
          }
        }), /*#__PURE__*/React.createElement(TooltipMenu, {
          trigger: dropdownTrigger
        }, /*#__PURE__*/React.createElement(TooltipMenu.Item, {
          onClick: function onClick() {
            _this.sendReminder(instance);
          }
        }, _this.props.translate('send-reminder')), /*#__PURE__*/React.createElement(TooltipMenu.Item, {
          onClick: function onClick() {
            _this.toggleBooking(instance);
          }
        }, _this.props.translate('book-meeting-time')))))));
      })));
    });

    _defineProperty(_assertThisInitialized(_this), "renderTimeSlot", function (slot, instance, index) {
      var _this$props = _this.props,
          meeting = _this$props.meeting,
          translate = _this$props.translate;
      var dropdownTrigger = /*#__PURE__*/React.createElement("div", {
        className: "dropdown--trigger"
      }, /*#__PURE__*/React.createElement(Icon, {
        name: "Bullets"
      }));
      return /*#__PURE__*/React.createElement("div", {
        className: "slot no-checkbox ".concat(!slot.bookable ? ' disabled' : ''),
        key: 'slot-' + index
      }, instance != null ? /*#__PURE__*/React.createElement(Link, {
        to: "/meeting/".concat(meeting.id, "/instance/").concat(instance.id)
      }, moment.utc(slot.startTime).local().format('HH:mm'), " ", instance.student.firstName + ' ' + instance.student.lastName) : slot.bookable ? /*#__PURE__*/React.createElement("span", null, moment.utc(slot.startTime).local().format('HH:mm')) : /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("p", {
        style: {
          textDecorationLine: 'line-through'
        }
      }, moment.utc(slot.startTime).local().format('HH:mm')), " ", translate('Non-bookable')), /*#__PURE__*/React.createElement(TooltipMenu, {
        trigger: dropdownTrigger
      }, instance != null ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TooltipMenu.Item, {
        onClick: function onClick() {
          _this.toggleBooking(instance);
        }
      }, _this.props.translate('Change meeting time'))) : null, instance == null ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TooltipMenu.Item, {
        onClick: function onClick() {
          return _this.setSlotBookable(meeting, slot, !slot.bookable);
        }
      }, slot.bookable ? _this.props.translate('Change to non-bookable') : _this.props.translate('Change to bookable'))) : null));
    });

    _defineProperty(_assertThisInitialized(_this), "renderTimeBlock", function (timeblock) {
      var instances = _this.props.meeting.instances.filter(function (t) {
        return t.date != null && moment.utc(t.date).local().isBetween(moment.utc(timeblock.startTime).subtract(5, 'seconds').local(), moment.utc(timeblock.endTime).add(5, 'seconds').local());
      });

      var dropdownTrigger = /*#__PURE__*/React.createElement("div", {
        onClick: function onClick(e) {
          return e.stopPropagation();
        },
        className: "dropdown--trigger"
      }, /*#__PURE__*/React.createElement(Icon, {
        name: "Bullets"
      }));

      var trigger = function trigger(open) {
        return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
          style: {
            display: 'flex'
          }
        }, /*#__PURE__*/React.createElement("div", {
          style: {
            flex: '1'
          }
        }, new DateTime(timeblock.startTime).getDateString().capitalize() + ' ' + (instances.length > 0 ? "(".concat(instances.length, ")") : '')), /*#__PURE__*/React.createElement("div", {
          style: {
            marginRight: '.35rem'
          }
        }, new DateTime(timeblock.startTime).getTime(), ' - ', new DateTime(timeblock.endTime).getTime()), /*#__PURE__*/React.createElement("div", null, !_this.disableTimeChange(timeblock) ? /*#__PURE__*/React.createElement(TooltipMenu, {
          trigger: dropdownTrigger
        }, /*#__PURE__*/React.createElement(TooltipMenu.Item, {
          onClick: function onClick() {
            _this.toggleTimeBlocksModal(timeblock);
          }
        }, _this.props.translate('Edit')), /*#__PURE__*/React.createElement(TooltipMenu.Item, {
          onClick: function onClick() {
            _this.removeTimeBlock(timeblock);
          }
        }, _this.props.translate('Delete'))) : null), /*#__PURE__*/React.createElement("div", {
          className: "open-indicator"
        }, open ? /*#__PURE__*/React.createElement(Minus, null) : /*#__PURE__*/React.createElement(Plus, null))));
      };

      var slots = timeblock === null || timeblock === void 0 ? void 0 : timeblock.timeBlockSlots.filter(function (t) {
        return moment(t.startTime) < moment(timeblock.endTime) && moment(t.endTime) > moment(timeblock.startTime);
      });
      return /*#__PURE__*/React.createElement("div", {
        className: "meeting--slots time-blocks bookedInstances",
        key: timeblock.id
      }, /*#__PURE__*/React.createElement(Collapsible, {
        ignorePropsUpdate: true,
        trigger: trigger
      }, slots.length == 0 ? /*#__PURE__*/React.createElement("div", {
        style: {
          paddingBottom: '1.9rem'
        }
      }, _this.props.translate('no-meeting-occasions')) : null, /*#__PURE__*/React.createElement("div", {
        className: "slots-container",
        style: {
          paddingBottom: '1.9rem'
        }
      }, slots.map(function (slot, index) {
        var foundInstance = instances.find(function (instance) {
          return moment.utc(instance.date).local() < moment.utc(slot.endTime).local() && moment.utc(instance.endDate).local() > moment.utc(slot.startTime).local();
        });
        return _this.renderTimeSlot(slot, foundInstance, index);
      }))));
    });

    _defineProperty(_assertThisInitialized(_this), "onboardingExit", function () {
      _this.setState({
        onboarding: !_this.state.onboarding
      });
    });

    moment.locale(getActiveLanguage());
    var onboarding = false;

    if (_this.getParameterByName('onboarding') != null) {
      onboarding = _this.getParameterByName('onboarding') == 'true';
      var firstOnboarding = localStorage.getItem('meeting-onboarding');

      if (firstOnboarding != null) {
        onboarding = false;
      } else {
        localStorage.setItem("meeting-onboarding", true);
      }
    }

    _this.state = {
      loading: true,
      timeBlocksModal: false,
      lengthValue: 0,
      restLengthValue: 0,
      bookingInstance: null,
      bookingModal: false,
      onboarding: onboarding,
      steps: [{
        target: '.occassions-datePickers',
        content: 'Här kan du sätta möteslängd och vilotid mellan samtalen',
        disableBeacon: true
      }, {
        target: '#unbookedInstances',
        content: 'Här kan du se personer som inte har bokat någon mötestid',
        disableBeacon: true
      }, {
        target: '.meeting-add-date-button',
        content: 'Här kan du lägga till nytt datum och sätta mellan vilka tider du är tillgänglig',
        disableBeacon: true
      }]
    };
    return _this;
  }
  /* Lifecycle methods */


  _createClass(MeetingOccassions, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      if (this.state.loading) {
        return /*#__PURE__*/React.createElement(Spinner, {
          center: true
        });
      }

      var meeting = this.props.meeting;
      return /*#__PURE__*/React.createElement("div", {
        className: "single-task meeting"
      }, this.state.onboarding ? /*#__PURE__*/React.createElement(Onboarding, {
        onExit: this.onboardingExit,
        steps: this.state.steps,
        onboarding: this.state.onboarding
      }) : null, /*#__PURE__*/React.createElement(Modal, {
        isOpen: this.state.timeBlocksModal,
        type: "small",
        onClose: function onClose() {
          return _this2.toggleTimeBlocksModal();
        },
        title: this.props.translate('add-date')
      }, /*#__PURE__*/React.createElement(CreateTimeBlocks, {
        onClose: this.toggleTimeBlocksModal,
        reference: meeting,
        timeblock: this.state.editTimeblock
      })), /*#__PURE__*/React.createElement(Modal, {
        isOpen: this.state.bookingModal,
        onClose: function onClose(instance, reload) {
          return _this2.toggleBooking(instance, reload);
        },
        type: "small",
        title: this.props.translate('book-meeting-time')
      }, /*#__PURE__*/React.createElement(BookMeeting, {
        onClose: function onClose(instance, reload) {
          _this2.toggleBooking(instance, reload);
        },
        meeting: this.props.meeting,
        instance: this.state.bookingInstance
      })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'flex'
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          flex: 1
        }
      }, /*#__PURE__*/React.createElement("span", {
        className: "title"
      }, this.props.translate('meeting-occasions'))), /*#__PURE__*/React.createElement("div", {
        className: "onboarding-help-container",
        onClick: function onClick() {
          _this2.setState({
            onboarding: !_this2.state.onboarding
          });
        }
      }, /*#__PURE__*/React.createElement(Icon, {
        name: "Help"
      })))), this.renderDatePickers(), /*#__PURE__*/React.createElement("div", {
        className: "meeting-time-blocks"
      }, this.props.meetingTimeBlocks.map(this.renderTimeBlock), this.renderUnbookedInstances()), /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: '2rem'
        },
        className: "meeting-add-date-button"
      }, /*#__PURE__*/React.createElement(Button, {
        style: {
          marginRight: '.75rem'
        },
        onClick: function onClick() {
          return _this2.toggleTimeBlocksModal();
        },
        type: "secondary"
      }, /*#__PURE__*/React.createElement(Icon, {
        name: "Plus"
      }), " ", this.props.translate('add-date')), /*#__PURE__*/React.createElement(Button, {
        onClick: this.sendReminderToAllUnbookInstances,
        type: "secondary"
      }, /*#__PURE__*/React.createElement(Icon, {
        name: "Bell",
        bw: true
      }), " ", this.props.translate('remind-unbooked')), this.props.next != null ? /*#__PURE__*/React.createElement("div", {
        className: "float--right"
      }, /*#__PURE__*/React.createElement(Button, {
        onClick: this.props.next
      }, this.props.translate('next'))) : null)), /*#__PURE__*/React.createElement("div", {
        className: "clearfix"
      }));
    }
  }]);

  return MeetingOccassions;
}(Component);

function mapStateToProps(state) {
  var meeting = state.Meetings.meeting;

  if (meeting == null && state.Meetings.wizardMeeting != null) {
    meeting = state.Meetings.wizardMeeting;
  }

  return {
    translate: translate(state.Languages.translations),
    meeting: meeting,
    user: state.user.currentUser,
    meetingTimeBlocks: state.TimeBlocks.meetingTimeBlocks,
    meetingTimeBlockSlots: state.TimeBlocks.meetingTimeBlockSlots,
    languages: state.Languages.languages
  };
}

export default connect(mapStateToProps, {
  getMeeting: getMeeting,
  updateMeeting: updateMeeting,
  addError: addError,
  getMeetingTimeBlocks: getMeetingTimeBlocks,
  deleteMeetingTimeBlock: deleteMeetingTimeBlock,
  sendMeetingInstanceTimeBookingReminder: sendMeetingInstanceTimeBookingReminder,
  updateMeetingTimeBlockSlot: updateMeetingTimeBlockSlot
})(MeetingOccassions);